export function TicketStatusBadge({ status }) {
  const label = status ? String(status).replaceAll("_", " ") : "—";
  const key = String(status || "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
  let styles = "bg-[var(--color-workspace)] text-[var(--color-text-secondary)]";
  if (key === "open" || key === "new") {
    styles = "bg-[var(--status-submitted-bg)] text-[var(--status-submitted-fg)]";
  } else if (key === "triggered") {
    styles = "bg-[var(--color-accent)]/12 text-[var(--color-accent)]";
  } else if (key === "inprogress" || key === "progress") {
    styles = "bg-[var(--status-published-bg)] text-[var(--status-published-fg)]";
  } else if (key === "waiting" || key === "onhold" || key === "hold") {
    styles = "bg-[var(--color-warning)]/15 text-[var(--color-warning)]";
  } else if (key === "resolved") {
    styles = "bg-[var(--status-archived-bg)] text-[var(--status-archived-fg)]";
  } else if (key === "closed") {
    styles = "bg-[var(--color-workspace)] text-[var(--color-text-secondary)]";
  } else if (key === "rejected") {
    styles = "bg-[var(--color-error)]/10 text-[var(--color-error)]";
  } else if (key === "duplicate") {
    styles = "bg-[var(--color-workspace)] text-[var(--color-text-secondary)]";
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap tracking-wide ${styles}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

export function TicketPriorityBadge({ priority }) {
  const label = priority || "—";
  const key = String(priority || "").toLowerCase();
  let styles = "bg-[var(--color-workspace)] text-[var(--color-text-secondary)]";
  if (key === "critical") styles = "bg-[var(--color-error)]/10 text-[var(--color-error)]";
  else if (key === "high") styles = "bg-[var(--color-warning)]/15 text-[var(--color-warning)]";
  else if (key === "medium") styles = "bg-[var(--status-submitted-bg)] text-[var(--status-submitted-fg)]";

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold whitespace-nowrap ${styles}`}
    >
      {label}
    </span>
  );
}
